const helpRequestConfig = `
query help_request_config($help_request_config_id:  ID!) {
    help_request_config(help_request_config_id: $help_request_config_id) {
        id
        state_code
        tote_slot_help_request{
            id
            qrcode_url{
              link_url
            }
            help_request_customers{
                customer { 
                    avatar
                    nickname
                    masked_telephone
                }
            }
        }
    }
}
`

const helpRequest = `
query help_request($help_request_id:  ID!) {
    help_request(help_request_id: $help_request_id) {
        id
        state_code
        customer { 
            avatar
        }
        qrcode_url{
            link_url
        }
    }
}
`

const CreateHelpRequestCustomer = `
mutation CreateHelpRequestCustomer($input: CreateHelpRequestCustomerInput!) {
    CreateHelpRequestCustomer(input: $input) {
        success
        banner { 
            extra
            link
            image_url
        }
        help_request {
            id
            state_code
            customer { 
                avatar
            }
            help_request_customers {
                customer {
                    avatar
                }
            }
        }
        errors {
            error_code
            message
        }
    }
}
`

export { helpRequestConfig, helpRequest, CreateHelpRequestCustomer }
